import Cookies from 'universal-cookie';

const AUTH_TOKEN = 'AUTH_TOKEN';
const cookies = new Cookies();
let token;

export const getToken = async () => {
  token = await cookies.get("AuthToken")
  return token;
  };

// Liefert den Pfad aus ?redirect=... – nur relative Pfade, damit nicht auf fremde Seiten weitergeleitet wird
export const getRedirectParam = () => {
  const redirect = new URLSearchParams(window.location.search).get("redirect");
  if (
    redirect &&
    redirect.startsWith("/") &&
    !redirect.startsWith("//") &&
    !redirect.startsWith("/\\")
  ) {
    return redirect;
  }
  return null;
};
